export const SCENES = {
  Boot: 'BootScene',
  Preload: 'PreloadScene',
  Intro: 'IntroScene',
  Game: 'GameScene',
  HUD: 'HUDScene',
  GameOver: 'GameOverScene',
} as const;

export type SceneKey = (typeof SCENES)[keyof typeof SCENES];

export enum ElephantStage {
  TINY = 0,
  SMALL = 1,
  MEDIUM = 2,
  LARGE = 3,
  GIANT = 4,
}

export type Lane = 0 | 1 | 2;

export type Difficulty = 'easy' | 'medium' | 'hard';

export type EntityKind = 'nutrient' | 'monster' | 'shield';

export interface PatternEntity {
  type: EntityKind;
  subtype?: string;
  lane: Lane;
  delay: number;
}

export interface SpawnPattern {
  id: string;
  difficulty: Difficulty;
  duration: number;
  entities: PatternEntity[];
}

export const GAME_EVENTS = {
  ScoreChanged: 'score-changed',
  StageChanged: 'stage-changed',
  ProgressChanged: 'progress-changed',
  TimerTick: 'timer-tick',
  NutrientCollected: 'nutrient-collected',
  MonsterHit: 'monster-hit',
  ShieldActivated: 'shield-activated',
  ShieldExpired: 'shield-expired',
  CountdownTick: 'countdown-tick',
  GameStarted: 'game-started',
  GameOver: 'game-over',
  GamePaused: 'game-paused',
  GameResumed: 'game-resumed',
} as const;

export type GameEvent = (typeof GAME_EVENTS)[keyof typeof GAME_EVENTS];

export interface NutrientCollectedPayload {
  key: string;
  value: number;
  isDielac: boolean;
  position: { x: number; y: number };
}

export interface StageChangedPayload {
  stage: ElephantStage;
  previousStage: ElephantStage;
  reason: 'levelup' | 'hit';
}

export interface MonsterHitPayload {
  position: { x: number; y: number };
}

export interface GameOverPayload {
  score: number;
  maxStage: ElephantStage;
  durationMs: number;
  reason: 'timer' | 'tiny-hit';
}

export interface ScorePayload {
  sessionId: string;
  seed: number;
  score: number;
  maxStage: ElephantStage;
  durationMs: number;
}

export interface MockSession {
  sessionId: string;
  seed: number;
  startedAt: number;
}
